import { autoinject, transient, bindable, computedFrom } from "aurelia-framework";
import { EntityFilterPropertyModel, EntityMetaDataModelOperator, QueryFilter } from "../../../models/queries/queries.models";
import { ExposedFiltersConfigModel } from "../../models";
import { Reflection } from "../../../utilities/reflection";

@autoinject
@transient()
export class WidgetConfigFilters {

    @bindable
    public filterProperties: Array<EntityFilterPropertyModel> = new Array<EntityFilterPropertyModel>();

    @bindable
    public exposedFilterProperties: ExposedFiltersConfigModel[];

    @bindable
    public filterOperators: { [index: string]: EntityMetaDataModelOperator[] };

    @bindable
    addExposedProperty: () => void; 

    @bindable
    removeExposedProperty: (index: number) => void;

    @bindable
    getControl: (filter: QueryFilter) => string;

    @computedFrom(Reflection.getPropertyName<WidgetConfigFilters>(x => x.exposedFilterProperties))
    get itemsToHide(){
        return this.exposedFilterProperties.filter(x => x && x.property && x.property.name).map( x => x.property);
    }

}
